import React from 'react';
import { Typography, Grid, useMediaQuery } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { IconUnderlay } from '@advisorycloud/react-ui-components';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import CardScene from '../../components/CardScene';

const useStyles = (isSM) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
    marginTop: '-10px',
    backgroundColor: isSM && 'common.white',
  },

  icon: {
    fontSize: '70px',
    color: 'error.main',
  },
  text: {
    maxWidth: 400,
    textAlign: 'center',
    color: 'secondary.dark',
  },
});

function OopsWindow() {
  const { t } = useTranslation();
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles(isSM);

  const RenderHeader = () => {
    return (
      <>
        <Typography variant="h2" color="textSecondary" sx={classes.text}>
          {t('OOPS')}
        </Typography>
      </>
    );
  };

  const RenderOopsWindow = () => {
    return (
      <>
        <Helmet>
          <title>{t('PASSWORD_RESET_HEADER_TITLE')}</title>
        </Helmet>
        <CardScene header={<RenderHeader />}>
          <div style={classes.container}>
            <Grid
              container
              justify="center"
              alignItems="center"
              direction="column"
              spacing={2}
            >
              <Grid item>
                <IconUnderlay size={90}>
                  <PriorityHighIcon style={classes.icon} />
                </IconUnderlay>
              </Grid>
              <Grid item>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  direction="column"
                >
                  <Typography
                    variant="h2"
                    color="textSecondary"
                    sx={classes.text}
                  >
                    {t('PASSWORD_RESET_LINK_ERROR')}
                  </Typography>
                  <Typography
                    variant="h2"
                    color="textSecondary"
                    sx={classes.text}
                  >
                    {t('PASSWORD_RESET_LINK_ERROR_ATTEMPT')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </CardScene>
      </>
    );
  };

  return (
    <>
      <RenderOopsWindow />
    </>
  );
}

export default OopsWindow;
